import { render, staticRenderFns } from "./IconsMaterial.vue?vue&type=template&id=03eecc79&"
import script from "./IconsMaterial.vue?vue&type=script&lang=js&"
export * from "./IconsMaterial.vue?vue&type=script&lang=js&"
import style0 from "./IconsMaterial.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VListItemSubtitle,VRow})
